// extracted by mini-css-extract-plugin
export default {"item":"menuItem_item__2h+on","buttonItem":"menuItem_buttonItem__HnjJG","link":"menuItem_link__-dFKZ","icon":"menuItem_icon__fbfp4","label":"menuItem_label__LgCUd"};